<div class="ngsild-home">
  <div class="ngsild-home__stepper">
    @for (step of steps; track step.key; let i = $index) {
      <div
        class="ngsild-home__step"
        [class.ngsild-home__step--active]="isStepActive(i)"
        [class.ngsild-home__step--completed]="isStepCompleted(i)"
        [class.ngsild-home__step--clickable]="isStepClickable(i)"
        (click)="onStepClick(i)"
      >
        <div class="ngsild-home__step-circle">
          @if (isStepCompleted(i)) {
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          } @else {
            <span>{{ i + 1 }}</span>
          }
        </div>
        <span class="ngsild-home__step-label">{{ step.label }}</span>
        @if (i < steps.length - 1) {
          <div
            class="ngsild-home__step-connector"
            [class.ngsild-home__step-connector--completed]="isStepCompleted(i + 1) || isStepActive(i + 1)"
          ></div>
        }
      </div>
    }
  </div>

  <lib-resource-server-summary resourceServer="file-server" />

  <div class="ngsild-home__main">
    <div class="ngsild-home__panel">
      <div class="ngsild-home__step-panel" [hidden]="currentStep() !== 0">
        <lib-ngsild-basic-info
          titlePlaceholder="Enter model title"
          (validChange)="onBasicValidChange($event)"
        />
      </div>
      <div class="ngsild-home__step-panel" [hidden]="currentStep() !== 1">
        <lib-model-metadata-info (validChange)="onMetadataValidChange($event)" />
      </div>
    </div>

    <div class="ngsild-home__actions">
      <button
        type="button"
        class="ngsild-home__btn ngsild-home__btn--secondary"
        [disabled]="isSubmitting()"
        (click)="onBackClick()"
      >
        {{ currentStep() > 0 ? '← Previous' : '← Back' }}
      </button>
      <button
        type="button"
        class="ngsild-home__btn ngsild-home__btn--primary"
        [disabled]="!canGoNext()"
        (click)="onNextClick()"
      >
        {{ nextButtonLabel() }}
      </button>
    </div>
  </div>
</div>
